// extracted by mini-css-extract-plugin
module.exports = {"link":"NativeLink_link__1JWHv"};